import { BorrowerStepStatus } from "./borrower-step-status.model";
export class BorrowerAppStatusDetails {
  visitedStepIds: string[] = [];
  borrowerStepStatuses: BorrowerStepStatus[] = [];
  applicationSubmitted: boolean = false;
  coBorrowerIds?: number[] = [];
  nonCoBorrowerIds?: number[] = [];
}
